import React from 'react';
import { FooterElementArchive } from './footer-element.component';
import { FooterElementUrl } from './footer-element-url.component';
import { useFooterConfiguration } from 'common/utils/configuration-hook';
export const FooterElementContainer = props => {
    const { footerType, visibleSetter } = props;
    const { hasArchive, text, url } = useFooterConfiguration(footerType);
    const visible = hasArchive || url ? true : false;
    React.useEffect(() => {
        if (visibleSetter) {
            visibleSetter(visible);
        }
    }, [visibleSetter, visible]);
    if (visible) {
        return React.createElement(React.Fragment, null, url ? (React.createElement(FooterElementUrl, Object.assign({}, { text, url }))) : (hasArchive ? React.createElement(FooterElementArchive, Object.assign({}, { text, footerType })) : React.createElement(React.Fragment, null)));
    }
    return React.createElement(React.Fragment, null);
};
